import React, { useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Modal } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { toAbsoluteUrl } from "../../../_helpers";
import { PhoneEnabledRounded, Email, LocalPrintshop } from "@material-ui/icons";
import { useMediaQuery } from "react-responsive";
import "./footer.css"
import enamad from "./mediaFooter/enamad2.png"
import khalag from "./mediaFooter/khalag.png"
import miras from "./mediaFooter/miras.png"
import samandehi from "./mediaFooter/samandehi2.png"
import daneshbonyan from "./mediaFooter/daneshbonyan2.png"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: theme.typography.fontWeightRegular,
    // fontSize:theme.typography.fontSize=17,
  },
  des: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: "2",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  typography: {
    padding: theme.spacing(2),
  },
}));



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "blanchedalmond",
  border: "none",
  borderRadius: "13px",
  boxShadow: 24,
  p: 5,
};

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  const classes = useStyles();

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = React.useState(isMobile ? true : false);
  const [collapsed2, setCollapsed2] = React.useState(isMobile ? true : false);

  const handleClick = () => {
    setOpen(true);
  };
  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  const fixDate = (number) => {
    let num;
    try {
      if (number && number < 10) {
        num = `0${number}`;
        return `0${number}`
      } else {
        return number;
      }
    } catch (error) {
      console.log("error in fixDate", number, error)
      return number;
    }
  }
  const tomorrowDate = () => {
    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var day = fixDate(currentDate.getDate()) // convert 7 => 07
    var month = fixDate(currentDate.getMonth() + 1)
    var year = currentDate.getFullYear()
    const tomorrowDate = `${year}-${month}-${day}`;
    return tomorrowDate;
  }
  var tomorrow = tomorrowDate();
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer bg-secondary py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer"
        style={{ minHeight: "14rem", height: "auto" }}
      >
        {/* begin::Container */}
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row justify-content-between`}
        >
          {/* begin::Copyright */}
          <div className="text-dark col-xs-6 col-md-3  order-2 order-md-1 mt-5">
            <div
              className="mb-5 d-flex align-items-baseline"
              style={{ cursor: "pointer" }}
            >
              <h4 style={{ fontWeight: "bold", lineHeight: 2, fontSize: 15 }}>ایباس</h4>
              <i
                onClick={() => setCollapsed2(!collapsed2)}
                className={`${collapsed2 ? "fa fa-angle-down" : "fa fa-angle-up"
                  } ml-2
                ${isMobile ? "d-block" : "d-none"}`}
              ></i>
            </div>
            {!collapsed2 ? (
              <div className="mt-3">
                <li className="limarker" style={{ lineHeight: 2 }}>
                  <NavLink className="limarker" to="/owner-contract">
                    <span className="limarker">سامانه ثبت مالکین</span>
                  </NavLink>
                </li>
                <ul style={{ paddingInlineStart: 18, fontSize: 13 }}>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/Extradition">
                      <span className="limarker">استرداد بلیط اتوبوس</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <a
                      className="limarker"
                      href="https://ebus.ir/mag"
                      target="_blank"
                    >
                      <span className="limarker">مجله ایباس</span>
                    </a>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/aboutus">
                      <span className="limarker">درباره ما</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/contact-us">
                      <span className="limarker">تماس با ما</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/jobs-opportunities">
                      <span className="limarker">فرصت های شغلی</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <a className="limarker" href="/bus-ticket/تهران/رشت">
                      <span className="limarker">بلیط اتوبوس تهران به رشت</span>
                    </a>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <a className="limarker" href="/bus-ticket/رشت/تهران">
                      <span className="limarker">بلیط اتوبوس رشت به تهران</span>
                    </a>
                  </li>
                </ul>
              </div>
            ) : null}
          </div>
          <div className="text-dark col-xs-6 col-md-3  order-2 order-md-1 mt-5">
            <div
              className="mb-5 d-flex align-items-baseline"
              style={{ cursor: "pointer" }}
            >
              <h4 style={{ fontWeight: "bold", lineHeight: 2, fontSize: 15 }}>راهنما</h4>
              <i
                onClick={() => setCollapsed(!collapsed)}
                className={`${collapsed ? "fa fa-angle-down" : "fa fa-angle-up"
                  } ml-2 ${isMobile ? "d-block" : "d-none"}`}
              ></i>
            </div>
            {!collapsed ? (
              <div className="mt-3">
                <ul style={{ paddingInlineStart: 18, fontSize: 13 }}>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/faq">
                      <span>سوالات متداول اتوبوسی</span>
                    </NavLink>
                  </li>
                  <li
                    className="limarker"
                    style={{ lineHeight: 2 }}
                  // onClick={handleClick}
                  >
                    {" "}
                    <NavLink className="limarker" to="/Conditions">
                      <span className="limarker">قوانین و مقررات</span>
                    </NavLink>

                  </li>
                  <li
                    className="limarker"
                    style={{ lineHeight: 2 }}
                    onClick={handleClick}
                  >
                    {" "}
                    <span>راهنمای خرید</span>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/passenger-rules">
                      <span className="limarker">حقوق مسافر</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/ebus-customer-rules">
                      <span className="limarker">امور مشتریان</span>
                    </NavLink>
                  </li>
                  <li className="limarker" style={{ lineHeight: 2 }}>
                    <NavLink className="limarker" to="/ebus-charter">
                      <span className="limarker">سرویس دربستی</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            ) : null}
          </div>
          <div className="text-dark col-xs-6 col-md-3  order-2 order-md-1 mt-5">
            <div className="mb-5">
              <h4 style={{ fontWeight: "bold", lineHeight: 2, fontSize: 15 }}>
                دانلود اپلیکیشن
              </h4>
            </div>
            <div className="mt-3  dis"  >
              <a className="mt-2 ">
                <img
                  className="image-foot"
                  src={toAbsoluteUrl(
                    "/media/ebusHomePics/coffe-bazzar.png"
                  )}
                  alt="ebus-footer"
                  width="60%"
                  height="100%"

                />
              </a>

              <a className="mt-2">
                <img
                  className="image-foot"
                  src={toAbsoluteUrl(
                    "/media/ebusHomePics/google-play.png"
                  )}
                  alt="ebus-footer"
                  width="60%"
                  height="100%"

                />
              </a>
            </div>

            <div className="mt-10 d-flex flex-column" >
              <span className="d-flex">
                <PhoneEnabledRounded />
                <span>
                  شماره تماس:
                  <a href="tel:02171057305"> 02171057305</a>
                </span>
              </span>
              <span className="d-flex">
                <LocalPrintshop />
                <span>
                  فکس:
                  <a href="tel:02433737932"> 02433737932</a>
                </span>
              </span>
              <span className="d-flex">
                <Email />
                <span>
                  ادرس پست الکترونیکی:
                  {/* <a href="mailto:info@ebus.ir"> info@ebus.ir</a> */}
                  <span className="color-link"> info@ebus.ir</span>
                </span>
              </span>
            </div>
          </div>

          <div className="text-dark col-xs-6 col-md-3 order-2 order-md-1 mt-5 ">
            <div className="mt-3 d-flex-column ">
              <ul className="ullogo row">
                {/* <li className=" d-flex lilogo "> */}

                <a referrerpolicy="origin" target="_blank"
                  className="col-3 p-0 m-2"
                  href="https://trustseal.enamad.ir/?id=228758&amp;Code=OuykS0b5WnPJNUuuMY9L">
                  <img referrerpolicy="origin"
                    // src="https://Trustseal.eNamad.ir/logo.aspx?id=228758&amp;Code=OuykS0b5WnPJNUuuMY9L"
                    src={enamad}
                    alt="ebus-enamad"
                    style={{ cursor: 'pointer', width: "100%", height: "100%" }}
                    id="OuykS0b5WnPJNUuuMY9L"
                  />
                </a>

                <img
                  className="col-3 p-0 m-2"
                  referrerpolicy="origin"
                  id="nbqejzpejxlzwlaosizpapfu"
                  style={{ cursor: "pointer" }}
                  width="100%"
                  height="100%"
                  rel="noopener noreferrer"
                  onClick={() => {
                    window.open(
                      "https://logo.samandehi.ir/Verify.aspx?id=271495&p=uiwkjyoerfthaodspfvldshw",
                      "_blank"
                    );
                  }}
                  alt="logo-samandehi"
                  src={samandehi}
                />
                <a
                  style={{ cursor: "pointer" }}
                  className="col-3 p-0 m-2"
                  // href={"https://ebus.ir/service/docs/certificate.pdf"}
                  onClick={() => {
                    window.open(
                      "https://ebus.ir/service/docs/certificate.pdf",
                      "_blank"
                    );
                  }}
                >
                  <img
                    referrerpolicy="origin"
                    id="daneshBonyan"
                    width="100%"
                    height="100%"
                    rel="noopener noreferrer"
                    alt="logo-daneshBonyan"
                    src={daneshbonyan}
                  />
                </a>
                <img
                  className="col-3 p-0 m-2"
                  referrerpolicy="origin"
                  id="daneshBonyan"
                  style={{ cursor: "pointer" }}
                  width="100%"
                  height="100%"
                  rel="noopener noreferrer"
                  alt="logo-daneshBonyan"
                  onClick={() => {
                    window.open(
                      "/certificate/khalaq",
                      "_blank"
                    );

                  }}
                  src={khalag}
                />
                <img
                  className="col-3 p-0 m-2"
                  referrerpolicy="origin"
                  id="daneshBonyan"
                  style={{ cursor: "pointer" }}
                  width="100%"
                  height="100%"
                  rel="noopener noreferrer"
                  alt="logo-daneshBonyan"
                  src={miras}
                  onClick={() => {
                    window.open(
                      "certificate/miras",
                      "_blank"
                    );
                  }}
                />
              </ul>
            </div>
          </div>
          {/* end::Copyright */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}

      <div
        className={`footer bg-secondary py-3 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer2"
      >
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row justify-content-between`}
        ></div>
      </div>

      <div
        className={`footer py-1 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer3"
        style={{ backgroundColor: "#656565" }}
      >
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row justify-content-between`}
          style={{ alignItems: "center" }}
        >
          <div className="mt-3">
            <span
              className="d-flex flex-wrap"
              style={{ fontWeight: "bold", lineHeight: 2, color: "white" }}
            >
              <NavLink
                className="limarker col-12 col-md-1 d-flex justify-content-center align-items-center"
                to="/"
              >
                <img
                  className="ml-1 my-2"
                  alt="ebus-footer"
                  width="100rem"
                  height="30px"
                  src={toAbsoluteUrl("/media/ebusHomePics/Ebus-logo-white.png")}
                />{" "}
              </NavLink>
              <span
                className="my-2 col-12 col-md-10 text-center"
                style={{ fontSize: "14px" }}
              >
                {" "}
                کلیه حقوق این سایت محفوظ و متعلق به راهکار سفر سروین می‌باشد.
              </span>
            </span>
          </div>
          <div className="text-dark mt-3">
            <div className="d-flex justify-content-around" style={{ gap: 10 }}>
              <div>
                <a
                  href="https://www.linkedin.com/company/ebus-ir/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/linkedin.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://twitter.com/ebus.ir"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/twitter.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.pinterest.com/ebusiran"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/pinterest.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>{" "}
              <div>
                <a
                  href="https://www.aparat.com/Ebus.ir"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/aparat.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
              <div>
                <a>
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/facebook.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://instagram.com/ebus.ir?utm_medium=copy_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={toAbsoluteUrl("/media/ebusHomePics/Instagram.png")}
                    alt="ebus-footer"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography className={classes.typography}>
            <ErrorOutlineOutlinedIcon
              className="mr-4"
              style={{ color: "green" }}
              fontSize="large"
            />
            این بخش به‌زودی فعال می‌شود
          </Typography>
        </Box>
      </Modal>
    </>
  )
}
